/* global FormData */
import ErrorMessage from "components/ErrorMessage";
import OButton from "components/reusable/OButton";
import useToastContext from "hooks/useToastContext";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { apiGet, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { AiFillCamera } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import OImage from "components/reusable/OImage";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import OSelect from "components/reusable/OSelect";
import OMultiSelect from "components/reusable/OMultiSelect";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import helper from "utils/helpers";
import helpers from "utils/helpers";
const EditAgentModal = ({ setEditShowModal, allAgent, item, totalAgents }) => {
  const { t } = useTranslation();
  const [isChecked, setChecked] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      firstName: item?.firstName,
      firstNameAr: item?.firstNameAr,
      lastName: item?.lastName,
      lastNameAr: item?.lastNameAr,
      email: item?.email,
      mobile: item?.countryCode + item?.mobile,
      brn: item?.brn,
      designation: item?.designation,
      designationAr: item?.designationAr,
      nationality: item?.nationality,
      country: item?.country,
      language: item?.language,
      isShowHome: item?.isShowHome,
      specializedArea: item?.communityId,
      order: item?.order,
      role: allAgent?.role,
      department: item?.department,
    },
  });
  const notification = useToastContext();
  // const [icon, setIcon] = useState(true)
  // const [passwordIcon, setPasswordIcon] = useState(true)
  const [roles, setRoles] = useState([]);
  const [language, setLanguage] = useState([]);
  const [nationalityArray, setNationalityArray] = useState([]);
  const [languageArray, setLanguageArray] = useState([]);
  const [isLanguageError, setIsLanguageError] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [communityArray, setCommunityArray] = useState([]);
  const [communityError, setIsCommunityError] = useState(false);
  const [community, setCommunity] = useState([]);
  const department = [
    { key: "all", value: "All" },
    { key: "residential", value: "Residential" },
    { key: "commercial", value: "Commercial" },
  ];
  const profilePicRef = useRef();
  const phoneInputRef = useRef();
  const validateFiles = (profilePicNew) => {
    let picError = "";
    const supportedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!isEmpty(supportedTypes.includes(profilePicNew.type))) {
      picError = "Only jpeg, jpg and png are supported.";
    }

    if (picError) {
      setProfilePicError(picError);
      return false;
    } else {
      setProfilePicError("");
      return true;
    }
  };
  const handleFileChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(image);
    if (isValidImage) {
      setProfilePic(image);
    } else {
      setProfilePic(null);
    }
  };
  const checkLanguage = () => {
    let isValid = true;
    if (language?.length === 0) {
      setIsLanguageError(true);
      isValid = false;
    } else {
      isValid = true;
      setIsLanguageError(false);
    }

    return isValid;
  };
  const checkSpecilized = () => {
    const isValid = community?.length !== 0;
    setIsCommunityError(!isValid);
    return isValid;
  };
  const onSubmit = async (data) => {
    try {
      //if(data.order &&(data.order < 1 || data.order > (Number(totalAgents)))){
      if (data.order && data.order < 1) {
        notification.error(`${t("PLEASE_ENTER_VALID_AGENT_ORDER")}`);
        return;
      }
      const isValid = checkLanguage();
      const isSpecialized = checkSpecilized();
      if (!isValid || !isSpecialized) return;

      const languages = language?.map((item) => item?.value).join(",");

      // Extract mobile and country code from PhoneInput
      data.mobile = data?.mobile?.substring(
        phoneInputRef?.current?.state.selectedCountry?.countryCode?.length,
        data?.mobile?.toString()?.length,
      );
      data.countryCode =
        phoneInputRef?.current?.state.selectedCountry?.countryCode;

      const formData = new FormData();
      formData.append("firstName", data.firstName);
      formData.append("firstNameAr", data.firstNameAr);
      formData.append("lastName", data.lastName);
      formData.append("lastNameAr", data.lastNameAr);
      formData.append("email", data.email);
      formData.append("countryCode", data.countryCode);
      formData.append("mobile", data.mobile);
      formData.append("brn", data.brn);
      // formData.append('country', data.country)
      formData.append("nationality", data.nationality);
      formData.append("language", languages);
      formData.append("designation", data.designation);
      formData.append("designationAr", data.designationAr);
      formData.append("order", data.order);

      formData.append("profilePic", profilePic);
      formData.append("isShowHome", isChecked);
      formData.append("role", data.role);
      formData.append("department", data.department);
      for (let i = 0; community.length > i; i++) {
        formData.append("communityId", community[i]?.value);
      }
      reset();
      const { data: response } = await apiPut(
        apiPath.addAgent + "/" + item._id,
        formData,
      );

      if (response.success) {
        notification.success(response.message);
        setEditShowModal(false);
        allAgent();
      } else {
        notification.error(response.message);
      }
    } catch (err) {
      console.error("err:", err);
    }
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };
  // const languageArray = [
  //   { label: 'English', value: 'English' },
  //   { label: 'German', value: 'German' },
  //   { label: 'Arabic', value: 'Arabic' },
  //   { label: 'Hindi', value: 'Hindi' }
  // ]
  // const nationalityArray = [
  //   { key: 'German', value: 'german' },
  //   { key: 'Afghan', value: 'afghan' },
  //   { key: 'Albanian', value: 'albanian' },
  //   { key: 'Algerian', value: 'algerian' }
  // ]
  // const countryArray = [
  //   { key: 'Germany', value: 'germany' },
  //   { key: 'France', value: 'france' },
  //   { key: 'Canada', value: 'canada' },
  //   { key: 'India', value: 'india' },
  //   { key: 'United States', value: 'US' }
  // ]
  useEffect(() => {
    getMasterData();
    getCommunities();
    setChecked(item?.isShowHome);
  }, []);

  // Set email and mobile values
  useEffect(() => {
    if (item?.email) {
      setValue("email", item?.email);
    }
    if (item?.mobile && item?.countryCode) {
      setValue("mobile", item?.countryCode + item?.mobile);
    }
  }, [item?.email, item?.mobile, item?.countryCode, setValue]);

  // Set nationality and role values after options are loaded
  useEffect(() => {
    if (nationalityArray.length > 0 && item?.nationality) {
      setValue("nationality", item?.nationality);
    }
  }, [nationalityArray, item?.nationality, setValue]);

  useEffect(() => {
    if (roles.length > 0) {
      if (item?.role) {
        setValue("role", item?.role);
      } else {
        // Set default role to the first role in the array
        const defaultRole = roles[0]?.label;

        setValue("role", defaultRole);
      }
    }
  }, [roles, item?.role, setValue]);

  const getMasterData = async () => {
    const response = await apiGet(apiPath.getUserMasterData);
    const tempNationality = response?.data?.results?.country?.map((newItem) => {
      return { key: newItem?.name, value: newItem?.name };
    });
    setNationalityArray(tempNationality);

    const tempLanguage = response?.data?.results?.language?.map((newItem) => {
      return { label: newItem?.name, value: newItem?.name };
    });
    setLanguageArray(tempLanguage);

    const defaultLanguage = item?.language.split(",");
    const tempDefaultLanguage = [];
    defaultLanguage?.map((lang) => {
      const tempOption = tempLanguage?.find(({ value }) => value === lang);
      tempDefaultLanguage.push(tempOption);
      return tempOption;
    });
    setLanguage(tempDefaultLanguage);

    const { data: rolesResponse } = await apiGet(apiPath.agentRoles);
    setRoles(rolesResponse?.results);
  };

  const getCommunities = async () => {
    const { data } = await apiGet(
      helpers.isSaudi()
        ? `${apiPath.allCommunities}?type=saudi`
        : apiPath.allCommunities,
    );
    const tempCommunity = data?.results?.map((newItem) => {
      return { label: newItem?.name, value: newItem?._id };
    });
    setCommunityArray(tempCommunity);

    const defaultCommunity = item?.communityId;
    const tempDefaultCommunity = [];
    defaultCommunity?.map((communities) => {
      const tempOption = tempCommunity?.find(
        (allCommunities) => allCommunities?.value === communities,
      );
      tempDefaultCommunity.push(tempOption);
      return tempOption;
    });
    setCommunity(tempDefaultCommunity);
  };

  return (
    <div>
      <>
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative my-6  w-full max-w-[1150px] mx-auto">
            <div className="sm:py-4 sm:px-2 py-8 px-7 ">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl font-semibold">{t("O_EDIT_AGENT")}</h3>
                  <button
                    className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                    onClick={() => setEditShowModal(false)}
                  >
                    <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                      ×
                    </span>
                  </button>
                </div>
                <div className="relative p-6 flex-auto">
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="firstName"
                        inputLabel={
                          <>
                            {t("O_FIRST_NAME")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        maxLength={15}
                        register={register(
                          "firstName",
                          formValidation.agentFirstName,
                          {},
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="firstNameAr"
                        inputLabel={
                          <>
                            {t("O_FIRST_NAME") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        maxLength={15}
                        register={register(
                          "firstNameAr",
                          formValidation.agentFirstNameAr,
                          {},
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="lastName"
                        inputLabel={
                          <>
                            {t("O_LAST_NAME")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        maxLength={15}
                        register={register(
                          "lastName",
                          formValidation.agentLastName,
                          {},
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="lastNameAr"
                        inputLabel={
                          <>
                            {t("O_LAST_NAME") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        maxLength={15}
                        register={register(
                          "lastNameAr",
                          formValidation.agentLastNameAr,
                          {},
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="email"
                        inputLabel={
                          <>
                            {t("O_EMAIL_ADDRESS")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="email"
                        register={register("email", formValidation.email)}
                        errors={errors}
                      />
                    </div>
                    <div
                      className="px-2"
                      style={{ position: "relative", zIndex: 100 }}
                    >
                      <div className="relative mb-6 w-full group">
                        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                          {t("O_MOBILE_NUMBER")}
                          <span className="text-red-500">*</span>
                        </label>
                        <Controller
                          name="mobile"
                          control={control}
                          rules={formValidation.mobile}
                          render={({ field: { onChange, value } }) => (
                            <PhoneInput
                              country={"sa"}
                              value={value}
                              onChange={onChange}
                              ref={phoneInputRef}
                              inputStyle={{
                                width: "100%",
                              }}
                              buttonStyle={{
                                zIndex: 1,
                              }}
                              dropdownStyle={{
                                zIndex: 99999,
                              }}
                              containerStyle={{
                                position: "relative",
                                zIndex: 1,
                              }}
                            />
                          )}
                        />
                        <ErrorMessage message={errors?.mobile?.message} />
                      </div>
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0   w-full group"
                        name="brn"
                        inputLabel={
                          <>
                            {t("O_BRN_NUMBER")}
                            {/* <span className='text-red-500'>*</span> */}
                          </>
                        }
                        onKeyPress={(e) => {
                          helper.isVarCharNumber(e);
                          helper.maxInputNumber(12, e);
                        }}
                        type="text"
                        register={register("brn")} //formValidation.brn
                        errors={errors}
                      />
                    </div>

                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0   w-full group"
                        name="designation"
                        inputLabel={
                          <>
                            {t("O_DESIGNATION")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register(
                          "designation",
                          formValidation.designation,
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0   w-full group"
                        name="designationAr"
                        inputLabel={
                          <>
                            {t("O_DESIGNATION") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register(
                          "designationAr",
                          formValidation.designationAr,
                        )}
                        errors={errors}
                      />
                    </div>

                    {/* <div className='px-2'>
                      <OSelect
                        wrapperClassName='relative z-0 mb-6 w-full group'
                        name='country'
                        inputLabel={
                          <>
                            {t('O_SELECT_COUNTRY')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='select'
                        selected={item?.country}
                        options={countryArray}
                        defaultValue={t('O_SELECT_COUNTRY')}
                        register={register('country', formValidation.country)}
                        errors={errors}
                      />
                    </div> */}
                    <div className="px-2">
                      <OSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="nationality"
                        inputLabel={
                          <>
                            {t("O_SELECT_NATIONALITY")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="select"
                        options={nationalityArray}
                        placeholder={t("O_SELECT_NATIONALITY")}
                        register={register(
                          "nationality",
                          formValidation.nationality,
                        )}
                        errors={errors}
                      />
                    </div>

                    <div className="px-2">
                      <div className="relative z-0 mb-6 w-full group">
                        <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                          {t("O_SELECT_LANGUAGE")}
                        </p>
                        <OMultiSelect
                          wrapperClassName="relative z-0 mb-6 w-full group"
                          name="language"
                          placeholder={
                            <>
                              {t("O_SELECT_LANGUAGE")}
                              <span className="text-red-500">*</span>
                            </>
                          }
                          options={languageArray}
                          defaultValue={t("O_SELECT_LANGUAGE")}
                          onChange={setLanguage}
                          value={language}
                        />
                        {isLanguageError && (
                          <ErrorMessage message="Please select language." />
                        )}
                      </div>
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6  w-full group"
                        name="order"
                        id="order"
                        inputLabel={<>{t("AGENT_ORDER")}</>}
                        type="number"
                        register={register("order")}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t("SPECIALIZED_AREA")}
                      </p>
                      <OMultiSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="specializedArea"
                        placeholder={
                          <>
                            {t("SPECIALIZED_AREA")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        options={communityArray}
                        defaultValue={t("SPECIALIZED_AREA")}
                        onChange={setCommunity}
                        value={community}
                      />
                      {communityError && (
                        <ErrorMessage message="Please select Specialized area." />
                      )}
                    </div>
                    <div className="px-2">
                      <OSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="role"
                        inputLabel={
                          <>
                            {t("O_SELECT_ROLE")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="select"
                        options={roles.map((item) => ({
                          key: item.label,
                          value: item.label,
                        }))}
                        placeholder={t("O_SELECT_ROLE")}
                        register={register("role", {
                          required: t("PLEASE_SELECT_ROLE"),
                        })}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OSelect
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="department"
                        inputLabel={
                          <>
                            {t("O_DEPARTMENT")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="select"
                        options={department.map((item) => ({
                          key: item.value,
                          value: item.value,
                        }))}
                        defaultValue={t("O_DEPARTMENT")}
                        register={register("department", {
                          required: t("PLEASE_SELECT_DEPARTMENT"),
                        })}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <div className="py-4 flex justify-start ml-2">
                        <div className="relative">
                          <label className="block mb-2 cursor-pointer text-sm font-medium text-gray-900 dark:text-white w-30">
                            {/* {!profilePic
                              ? ( */}
                            <span
                              className="flex align-center bg-[#8FC150] hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150
                                undefined "
                              onClick={() => profilePicRef?.current?.click()}
                            >
                              {t("UPLOAD_PROFILE_PICTURE")}
                            </span>
                            {/* )
                              : (
                                <span className='bg-[#8FC150] hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150
                                undefined ' >
                                  {t('UPLOAD_PROFILE_PICTURE')}
                                </span>
                                )} */}
                          </label>
                          <div>
                            <input
                              type="file"
                              accept="image/png, image/jpg, image/jpeg"
                              name="profilePic"
                              ref={profilePicRef}
                              onChange={handleFileChange}
                              className="hidden"
                            />

                            <div className="relative">
                              {(profilePic || item?.profilePic) && (
                                <OImage
                                  src={
                                    profilePic !== ""
                                      ? URL.createObjectURL(profilePic)
                                      : item?.profilePic
                                  }
                                  fallbackUrl="/images/user.png"
                                  className="w-24 h-24 m-auto"
                                  alt=""
                                  style={{ borderRadius: "50%" }}
                                />
                              )}

                              {(profilePic || item?.profilePic) && (
                                <AiFillCamera
                                  className=" bg-gray-100  absolute w-4 rounded-xl cursor-pointer "
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    bottom: "0",
                                    right: "50px",
                                    background: "",
                                    padding: "1px",
                                  }}
                                  onClick={() =>
                                    profilePicRef?.current?.click()
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center mt-4">
                        <ErrorMessage message={profilePicError} />
                      </div>
                    </div>
                    <div
                      className="px-2"
                      style={{ alignItems: "center", display: "flex" }}
                    >
                      <label>{t("SHOW_HOME")}</label>
                      <input
                        className="ml-2 group"
                        name="isShowHome"
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        register={register("isShowHome")}
                        errors={errors}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setEditShowModal(false)}
                  >
                    {t("O_BACK")}
                  </button>

                  <OButton
                    label={<>{t("SAVE")}</>}
                    type="submit"
                    onClick={handleSubmit(onSubmit, () => {
                      checkLanguage();
                      checkSpecilized();
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" />
      </>
    </div>
  );
};

export default EditAgentModal;
